export default [
    {
        key: 'events.guestlists.details.rsvps',
        type: 'route',
        route: 'app.guestlists.rsvps.index',
        right: 'rsvps::list',
        children: [
            {
                key: 'events.guestlists.details.rsvp-details.main',
                type: 'placeholder',
                showInNavigation: false,
                children: [
                    {
                        key: 'events.guestlists.details.rsvp-details.overview',
                        type: 'route',
                        route: 'app.guestlists.rsvps.details.overview',
                        right: 'rsvps::view'
                    },
                    {
                        key: 'events.guestlists.details.rsvp-details.messages',
                        type: 'route',
                        route: 'app.guestlists.rsvps.details.messages',
                        right: 'rsvps::messages'
                    },
                    {
                        key: 'events.guestlists.details.rsvp-details.checkins',
                        type: 'route',
                        route: 'app.guestlists.rsvps.details.checkins',
                        right: 'rsvps::checkins'
                    },
                    {
                        key: 'events.guestlists.details.rsvp-details.guests',
                        type: 'route',
                        route: 'app.guestlists.rsvps.details.guests',
                        right: 'rsvps::list',
                        customAccessor($injector) {
                            return _.get($injector.get('$stateParams'), 'guestlist.settings.enable_guests', false);
                        }
                    },
                    {
                        key: 'events.guestlists.details.rsvp-details.changelog',
                        type: 'route',
                        route: 'app.guestlists.rsvps.details.changelog',
                        right: 'rsvps::view'
                    },
                    {
                        key: 'events.guestlists.details.rsvp-details.option-links',
                        type: 'route',
                        route: 'app.guestlists.rsvps.details.option-links',
                        right: 'bookable_objects::option_link_list',
                        customAccessor($injector) {
                            const stateParams = $injector.get('$stateParams');

                            return stateParams.guestlist && stateParams.guestlist.bo_objects.length > 0;
                        }
                    },
                    {
                        key: 'events.guestlists.details.rsvp-details.edit',
                        type: 'route',
                        route: 'app.guestlists.rsvps.details.edit',
                        right: 'rsvps::edit',
                        showInNavigation: false,
                        hideTabNav: true
                    }
                ]
            }
        ]
    },
    {
        key: 'events.guestlists.details.seatplan',
        type: 'route',
        route: 'app.guestlists.rsvps.seats',
        right: 'guestlists::seats',
        customAccessor($injector) {
            return !!_.get($injector.get('$stateParams'), 'guestlist.seatplan_id', null);
        }
    },
    {
        key: 'events.guestlists.details.messages.main',
        type: 'placeholder',
        children: [
            {
                key: 'events.guestlists.details.messages.overview',
                type: 'route',
                route: 'app.guestlists.rsvps.messages.overview',
                right: 'messages::list'
            },
            {
                key: 'events.guestlists.details.messages.templates',
                type: 'route',
                route: 'app.guestlists.rsvps.messages.templates',
                right: 'guestlists::list-templates'
            },
            {
                key: 'events.guestlists.details.messages.sent',
                type: 'route',
                route: 'app.guestlists.rsvps.messages.sent',
                right: 'messages::list'
            },
            {
                key: 'events.guestlists.details.messages.settings',
                type: 'route',
                route: 'app.guestlists.rsvps.messages.settings',
                right: 'guestlists::edit'
            },
        ]
    },
    {
        key: 'events.guestlists.details.landingpage',
        type: 'route',
        route: 'app.guestlists.rsvps.edit-landingpage-settings',
        right: 'guestlists::edit',
        customAccessor($injector) {
            return $injector.get('Acl').hasWorkflow('rsvps::list.edit-landingpage-settings');
        },
    },
    {
        key: 'events.guestlists.details.center-stage',
        type: 'route',
        route: 'app.guestlists.rsvps.center-stage',
        right: 'guestlists::edit',
        showInNavigation: false,
        customAccessor($injector) {
            return $injector.get('Acl').hasWorkflow('rsvps::list.edit-landingpage-settings');
        }
    },
    {
        key: 'events.guestlists.details.tickets.main',
        type: 'placeholder',
        customAccessor($injector) {
            const aclService = $injector.get('Acl');

            return aclService.hasRight('tickets::templates-view') || aclService.hasRight('passbooks::view');
        },
        children: [
            {
                key: 'events.guestlists.details.tickets.settings',
                type: 'route',
                route: 'app.guestlists.rsvps.tickets.settings',
                right: 'guestlists::edit'
            },
            {
                key: 'events.guestlists.details.tickets.pdf-ticket',
                type: 'route',
                route: 'app.guestlists.rsvps.tickets.pdf-ticket',
                right: 'tickets::templates-view',
                customAccessor($injector) {
                    return !!_.get($injector.get('$stateParams'), 'guestlist.ticket_template_id', null);
                }
            },
            {
                key: 'events.guestlists.details.tickets.wallet-ticket',
                type: 'route',
                route: 'app.guestlists.rsvps.tickets.wallet-ticket',
                right: 'passbooks::view',
                customAccessor($injector) {
                    return !!_.get($injector.get('$stateParams'), 'guestlist.passbook_id', null);
                }
            },
        ]
    },
    {
        key: 'events.guestlists.details.bookable-objects.main',
        type: 'placeholder',
        customAccessor($injector) {
            return $injector.get('Acl').hasModule('bookable_objects');
        },
        children: [
            {
                key: 'events.guestlists.details.bookable-objects.option-links',
                type: 'route',
                route: 'app.guestlists.rsvps.option-links',
                right: 'bookable_objects::option_link_list'
            }
        ]
    },
    {
        key: 'events.guestlists.details.import',
        type: 'route',
        route: 'app.guestlists.rsvps.import',
        right: 'rsvps::import',
        customAccessor($injector) {
            return $injector.get('Acl').hasWorkflow('rsvps::list.import-rsvps');
        }
    },
    {
        key: 'events.guestlists.details.limits',
        type: 'route',
        route: 'app.guestlists.rsvps.limits',
        right: 'guestlists::view-limits',
        customAccessor($injector) {
            return $injector.get('Acl').hasWorkflow('rsvps::list.guestlist-limits');
        }
    },
    {
        key: 'events.guestlists.details.overview',
        type: 'route',
        route: 'app.guestlists.rsvps.overview',
        right: 'guestlists::view'
    },
    {
        key: 'events.guestlists.details.release-settings',
        type: 'route',
        route: 'app.guestlists.rsvps.release-settings',
        right: 'guestlists::edit',
        customAccessor($injector) {
            return !!_.get($injector.get('$stateParams'), 'guestlist.seatplan_id', null);
        }
    },
    {
        key: 'events.guestlists.details.public-seats',
        type: 'route',
        route: 'app.guestlists.rsvps.public_seats',
        right: 'guestlists::edit',
        customAccessor($injector) {
            return !!_.get($injector.get('$stateParams'), 'guestlist.seatplan_id', null);
        }
    },
    {
        key: 'events.guestlists.details.short-term-settings',
        type: 'route',
        route: 'app.guestlists.rsvps.short-term-settings',
        right: 'guestlists::edit',
        customAccessor($injector) {
            return !!_.get($injector.get('$stateParams'), 'guestlist.settings.enable_short_term_reservation', null);
        }
    },
    {
        key: 'events.guestlists.details.settings',
        type: 'route',
        route: 'app.guestlists.rsvps.edit-settings',
        right: 'guestlists::edit',
        customAccessor($injector) {
            return $injector.get('Acl').hasWorkflow('rsvps::list.edit-guestlist-settings');
        }
    },
    {
        key: 'events.guestlists.details.duplicates',
        type: 'route',
        route: 'app.guestlists.rsvps.duplicates',
        right: 'rsvps::duplicates',
        customAccessor($injector) {
            return $injector.get('Acl').hasWorkflow('rsvps::list.show-rsvp-duplicates');
        }
    },
    {
        key: 'events.guestlists.details.changelog',
        type: 'route',
        route: 'app.guestlists.rsvps.changelog',
        right: 'rsvps::changelog'
    },
    {
        key: 'events.guestlists.details.protected-files',
        type: 'route',
        route: 'app.guestlists.rsvps.protected-files',
        right: 'guestlists::protected-files'
    },

    {
        key: 'events.guestlists.details.create-rsvp',
        type: 'route',
        route: 'app.guestlists.rsvps.create',
        right: 'rsvps::create',
        showInNavigation: false,
        hideTabNav: true
    },
];



// WEBPACK FOOTER //
// ./src/app/modules/navigation/resources/sub/guestlist-details.js